module.exports = __webpack_public_path__ + "media/img/facebook-icon-035bcfca0c486b79cc8315fca64ff7e7.png";